<template>
  <div class="user-profile-title">
    <slot/>
    <span class="counter" v-if="counter !== undefined">{{counter}}</span>
  </div>
</template>

<script>
  export default {
    name: 'UserProfileTitle',
    props: {
      counter: [Number, String],
    }
  }
</script>

<style scoped lang="stylus">
  .user-profile-title
    text-transform uppercase
    color #4ba3e2
    font-weight bold
    margin-bottom 10px

    .counter
      color #ababab
      margin-left 10px
      font-weight 500
</style>
